let analyticsService = null;

export const handleWelcomeConscentClick = async (event: Event) => {
    if (window['AIBA'] && window['AIBA']['utils']) {
      const handlers = window['AIBA']['utils'];
      const { currentIntroIndex } = await handlers.getQuizState();
  
      let breadcrumb = await handlers.getBreadCrumbState();
      breadcrumb = breadcrumb.map(item => (item.name === 'welcome_screen' ? { ...item, enabled: true } : item));
      await handlers.updateBreadCrumbState([...breadcrumb]);
      await handlers.setHideVTOScreen(true);
      document?.querySelector('aiba-app')?.setAttribute('style', 'min-height:auto');
      window['AIBA']['utils'].getNextJourney('welcome_screen');
      analyticsService = handlers.analyticsService;
  
      if (currentIntroIndex === 0) {
        let quizInfo: string = '';
        const retake = await handlers.getStateRetakeJourney();
        quizInfo = `hair analysis - ${retake ? 'retake' : 'take'} quiz`;
        event['data'] = { label: quizInfo };
        event['virtualAgent'] = quizInfo;
        analyticsService?.registerEvent('event16', event);
      } else {
        analyticsService?.registerEvent('event2', { ...event, target: event.currentTarget });
      }
  
      console.log(handlers, event, '@AIBA[analyticsHandler]');
    }
  };

  export const customLinkClick = async (event: Event) => {
    if (window['AIBA'] && window['AIBA']['utils']) {
        const handlers = window['AIBA']['utils'];
        analyticsService = handlers.analyticsService;
        analyticsService?.registerEvent('event2', { ...event, target: event.currentTarget });
    }
  }